var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___bXAxeH",
  "layer": "Modal.module__layer___bXAxeH",
  "backdropSlot": "Modal.module__backdropSlot___bXAxeH",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___bXAxeH",
  "backdropCentered": "Modal.module__backdropCentered___bXAxeH",
  "focusLock": "Modal.module__focusLock___bXAxeH",
  "surface": "Modal.module__surface___bXAxeH",
  "layerFullscreen": "Modal.module__layerFullscreen___bXAxeH",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___bXAxeH",
  "layerCentered": "Modal.module__layerCentered___bXAxeH",
  "root": "Modal.module__root___bXAxeH",
  "centeredOnMobile": "Modal.module__centeredOnMobile___bXAxeH",
  "rootAnimating": "Modal.module__rootAnimating___bXAxeH",
  "medium": "Modal.module__medium___bXAxeH",
  "small": "Modal.module__small___bXAxeH",
  "large": "Modal.module__large___bXAxeH",
  "xlarge": "Modal.module__xlarge___bXAxeH",
  "fullscreen": "Modal.module__fullscreen___bXAxeH",
  "layout": "Modal.module__layout___bXAxeH",
  "header": "Modal.module__header___bXAxeH",
  "light": "Modal.module__light___bXAxeH",
  "dark": "Modal.module__dark___bXAxeH",
  "footer": "Modal.module__footer___bXAxeH",
  "stretchButtons": "Modal.module__stretchButtons___bXAxeH",
  "headerInner": "Modal.module__headerInner___bXAxeH",
  "headerText": "Modal.module__headerText___bXAxeH",
  "content": "Modal.module__content___bXAxeH",
  "contentNoPadding": "Modal.module__contentNoPadding___bXAxeH",
  "screenReaderLabel": "Modal.module__screenReaderLabel___bXAxeH",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___bXAxeH",
  "insetCloseButton": "Modal.module__insetCloseButton___bXAxeH",
  "contentLayout": "Modal.module__contentLayout___bXAxeH",
  "description": "Modal.module__description___bXAxeH",
  "inputGroup": "Modal.module__inputGroup___bXAxeH",
  "formFooter": "Modal.module__formFooter___bXAxeH",
};

__webpack_require__.r(module.exports = exports);
